import { render, staticRenderFns } from "./OnboardingSVG.vue?vue&type=template&id=80746714&"
import script from "./OnboardingSVG.vue?vue&type=script&lang=js&"
export * from "./OnboardingSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports